import { render, staticRenderFns } from "./level.vue?vue&type=template&id=52b5f61a&"
import script from "./level.vue?vue&type=script&lang=js&"
export * from "./level.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b5f61a')) {
      api.createRecord('52b5f61a', component.options)
    } else {
      api.reload('52b5f61a', component.options)
    }
    module.hot.accept("./level.vue?vue&type=template&id=52b5f61a&", function () {
      api.rerender('52b5f61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotScore/level.vue"
export default component.exports